import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import SchoolFood from '@/components/SchoolFood'
import SchoolFoodListPerson from '@/components/SchoolFoodListPerson'
import Login from '@/components/Auth/Login'
import User from '@/components/Auth/User'

import GISGMPRoot from '@/components/gis_gmp/charge/root'
import GISGMPListPayer from '@/components/gis_gmp/charge/listPayer'
import GISGMPPayer from '@/components/gis_gmp/charge/payer'
import GISGMPCharges from '@/components/gis_gmp/charge/charges'
import GISGMPCharge from '@/components/gis_gmp/charge/charge'
import GISGMPListExportPaymentFromCharge from '@/components/gis_gmp/charge/listExportPaymentFromCharge'

import GISGMPListExportPayment from '@/components/gis_gmp/listExportPayment'

import GISGMPForcedAcknowledgementCard from '@/components/gis_gmp/charge/forcedAcknowledgement/card'
import GISGMPForcedAcknowledgementReceipt from '@/components/gis_gmp/charge/forcedAcknowledgement/receipt'
import GISGMPForcedAcknowledgementDispatchReport from '@/components/gis_gmp/charge/forcedAcknowledgement/dispatchReport'
import GISGMPReceiptExportPayment from '@/components/gis_gmp/charge/receiptExportPayment'

import GISGMPPrepareChargeRoot from '@/components/gis_gmp/prepare_charge/root'
import GISGMPPrepareChargeList from '@/components/gis_gmp/prepare_charge/listChargeForPrparation'
import GISGMPPackage from '@/components/gis_gmp/prepare_charge/package'

import GISGMPReferenceTables from '@/components/gis_gmp/reference_tables/root'
import GISGMPReferenceKBK from '@/components/gis_gmp/reference_tables/kbk'

import GISGMPReports from '@/components/gis_gmp/reports/root'
import GISGMPReportCharge from '@/components/gis_gmp/reports/charge'
import GISGMPReportConsolidatedCharges from '@/components/gis_gmp/reports/consolidated_charges'
// import GISGMPReportCoincidenceChargePayment from '@/components/gis_gmp/reports/coincidence_charge_payment'
import GISGMPReportWorkKDNMonth from '@/components/gis_gmp/reports/work_kdn_month'

import Files from '@/components/gku_reestr/Files'
import GKURootReceipt from '@/components/gku_reestr/root_receipt'
import GKUAccounts from '@/components/gku_reestr/accounts'
import GKUReceipt from '@/components/gku_reestr/receipt'

// import KgChildrenList101 from '@/components/kindergarten_101/KgChildrenList101'
// import KgReestrList101 from '@/components/kindergarten_101/KgReestrList101'

import ASRoot from '@/components/accounting_software/root'
import ASSoftwareList from '@/components/accounting_software/software/list'
import ASSoftwareCard from '@/components/accounting_software/software/card'
import ASDocumentList from '@/components/accounting_software/document/list'
import ASDocumentCard from '@/components/accounting_software/document/card'
import ASReports from '@/components/accounting_software/reports/root'
import ASReportAcceptanceAct from '@/components/accounting_software/reports/acceptanceAct'
import ASReportAccountingSoftwareList from '@/components/accounting_software/reports/accountingSoftwareList'
import ASReportFullAccountingSoftwareList from '@/components/accounting_software/reports/fullAccountingSoftwareList'
import ASReportWriteOffAct from '@/components/accounting_software/reports/writeOffAct'

import HemodialysisRoot from '@/components/hemodialysis/root'
import HemodialysisListPerson from '@/components/hemodialysis/listPerson'
import HemodialysisPerson from '@/components/hemodialysis/person'
import HemodialysisListService from '@/components/hemodialysis/listService'
import HemodialysisService from '@/components/hemodialysis/service'

import ReportingRoot from '@/components/reporting/root'
import ReportingRootReport from '@/components/reporting/root_report'
import ReportingTypes from '@/components/reporting/types'
import ReportingList from '@/components/reporting/list'
import ReportingReport from '@/components/reporting/report'
import ReportingReportTypeDepartmentList from '@/components/reporting/report_type_department/list'
import ReportingReportTypeDepartmentCard from '@/components/reporting/report_type_department/card'
import ReportingReportDepartmentList from '@/components/reporting/department/list'

import KindergartenRoot from '@/components/kindergarten/root'
import KindergartenInformation from '@/components/kindergarten/information'
import KindergartenList from '@/components/kindergarten/list'
import KindergartenRegistry from '@/components/kindergarten/registry'

import store from '../store'

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next()
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    })
}

const requireAuthenticatedRole = (to, from, next) => {
  store.dispatch('auth/initialize').then(() => {
    let isAuthenticated = store.getters['auth/isAuthenticated']
    let user = store.getters['auth/user']
    if (!isAuthenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      if (user.username === '') {
        store.dispatch('auth/user').then(() => {
          if (store.getters['auth/groupAccessAllowed'](to.meta.groups)) {
            next()
          } else {
            next({
              path: '/home'
            })
          }
        })
      } else {
        if (store.getters['auth/groupAccessAllowed'](to.meta.groups)) {
          next()
        } else {
          next({
            path: '/home'
          })
        }
      }
    }
  })
}

Vue.use(Router)

// const SITE_PREFIX = '/oktapod'
export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      beforeEnter: requireAuthenticated
    },
    {
      path: '/school_food',
      name: 'schoolFood',
      component: SchoolFood,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - Школы - Питание'],
        groups_menu: ['Oktapod - Школы - Питание'],
        title: 'Школы. Питание',
        icon: 'mdi-view-list'
      }
    },
    {
      path: '/school_food/school_food_list_person/:id',
      name: 'schoolFoodListPerson',
      component: SchoolFoodListPerson,
      beforeEnter: requireAuthenticatedRole,
      meta: { groups: ['Oktapod - Школы - Питание'] }
    },
    {
      path: '/gis_gmp',
      name: 'gis_gmp',
      component: GISGMPRoot,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: [
          'Oktapod - КДН - ГИС ГМП',
          'Oktapod - КДН - ГИС ГМП - бухгалтерия'
        ],
        groups_menu: [
          'Oktapod - КДН - ГИС ГМП',
          'Oktapod - КДН - ГИС ГМП - бухгалтерия'
        ],
        title: 'ГИС ГМП',
        icon: 'mdi-view-list'
      },
      children: [
        {
          path: 'list',
          name: 'gis_gmp_list_payer',
          component: GISGMPListPayer,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'
            ],
            groups_menu: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            title: 'Начисления',
            icon: 'mdi-view-list'
          }
        },
        { path: 'list/:payer_id',
          name: 'gis_gmp_payer',
          component: GISGMPPayer,
          beforeEnter: requireAuthenticatedRole,
          meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] },
          children: [
            {
              path: 'charges',
              name: 'gis_gmp_charges',
              component: GISGMPCharges,
              beforeEnter: requireAuthenticatedRole,
              meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
            },
            { path: 'charges/:charge_id',
              name: 'gis_gmp_charge',
              component: GISGMPCharge,
              beforeEnter: requireAuthenticatedRole,
              meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
            }
          ]
        },
        { path: 'export_payment/:charge_id/:forcedAcknowledgement_id',
          name: 'gis_gmp_export_payment',
          component: GISGMPListExportPaymentFromCharge,
          beforeEnter: requireAuthenticatedRole,
          meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
        },
        {
          path: 'export_payment',
          name: 'gis_gmp_export_payment0',
          component: GISGMPListExportPayment,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'
            ],
            groups_menu: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            title: 'Список квитанций об уплате',
            icon: 'mdi-view-list'
          }
        },
        { path: 'receipt/:id',
          name: 'gis_gmp_receipt_export_payment',
          component: GISGMPReceiptExportPayment,
          beforeEnter: requireAuthenticatedRole,
          meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
        },
        { path: 'forced_acknowledgement/:charge_id/:id',
          name: 'gis_gmp_forced_acknowledgement_card',
          component: GISGMPForcedAcknowledgementCard,
          beforeEnter: requireAuthenticatedRole,
          meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
        },
        { path: 'forced_acknowledgement_receipt/:id',
          name: 'gis_gmp_forced_acknowledgement_receipt',
          component: GISGMPForcedAcknowledgementReceipt,
          beforeEnter: requireAuthenticatedRole,
          meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
        },
        { path: 'forced_acknowledgement_dispatch_report/:id',
          name: 'gis_gmp_forced_acknowledgement_dispatch_report',
          component: GISGMPForcedAcknowledgementDispatchReport,
          beforeEnter: requireAuthenticatedRole,
          meta: { groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'] }
        },
        {
          path: 'prepare_charge',
          name: 'gis_gmp_prepare_charge',
          component: GISGMPPrepareChargeRoot,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            groups_menu: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            title: 'Обмен',
            icon: 'mdi-ballot'
          },
          children: [
            { path: 'list',
              name: 'gis_gmp_prepare_charge_list',
              component: GISGMPPrepareChargeList,
              meta: {
                groups: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                groups_menu: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                title: 'Обмен с ГИС ГМП',
                icon: 'mdi-ballot'
              }
            },
            { path: 'package',
              name: 'gis_gmp_package',
              component: GISGMPPackage,
              meta: {
                groups: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                groups_menu: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                title: 'Пакеты',
                icon: 'mdi-ballot'
              }
            }
          ]
        },
        {
          path: 'reference_tables',
          name: 'gis_gmp_reference_tables',
          component: GISGMPReferenceTables,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            groups_menu: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            title: 'Справочники',
            icon: 'mdi-ballot'
          },
          children: [
            {
              path: 'kbk',
              name: 'gis_gmp_reference_kbk',
              component: GISGMPReferenceKBK,
              meta: {
                groups: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                groups_menu: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                title: 'КБК',
                icon: 'mdi-ballot'
              }
            }
          ]
        },
        {
          path: 'reports',
          name: 'gis_gmp_reports',
          component: GISGMPReports,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            groups_menu: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            title: 'Отчеты',
            icon: 'mdi-notebook-multiple'
          },
          children: [
            {
              path: 'charge',
              name: 'gis_gmp_report_charge',
              component: GISGMPReportCharge,
              meta: {
                groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                groups_menu: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                title: 'Реестр начислений',
                icon: 'mdi-notebook'
              }
            },
            {
              path: 'consolidated-charges',
              name: 'gis_gmp_report_consolidated_charges',
              component: GISGMPReportConsolidatedCharges,
              meta: {
                groups: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                groups_menu: ['Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                title: 'Сводный отчет по начислениям',
                icon: 'mdi-notebook'
              }
            },
            // {
            //   path: 'coincidence-charge-payment',
            //   name: 'gis_gmp_report_coincidence_charge_payment',
            //   component: GISGMPReportCoincidenceChargePayment,
            //   meta: {
            //     groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            //     groups_menu: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
            //     title: 'Реестр совпавших несквитированных начислений с несквитированными уплатами',
            //     icon: 'mdi-notebook'
            //   }
            // },
            {
              path: 'work-kdn-month',
              name: 'gis_gmp_report_work_kdn_month',
              component: GISGMPReportWorkKDNMonth,
              meta: {
                groups: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                groups_menu: ['Oktapod - КДН - ГИС ГМП', 'Oktapod - КДН - ГИС ГМП - бухгалтерия'],
                title: 'Информация о количестве направленных начислений в ГИС ГМП за период',
                icon: 'mdi-notebook'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/gku_files',
      name: 'gku_files',
      component: Files,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - ЖКУ - Реестр лицевых счетов'],
        groups_menu: ['Oktapod - ЖКУ - Реестр лицевых счетов'],
        title: 'ЖКУ. Реестры',
        icon: 'mdi-view-list'
      }
    },
    {
      path: '/gku_receipt',
      name: 'gku_root_receipt',
      component: GKURootReceipt,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - ЖКУ - Ручной ввод'],
        groups_menu: ['Oktapod - ЖКУ - Ручной ввод'],
        title: 'ЖКУ. Квитанции',
        icon: 'mdi-view-list'
      },
      children: [
        {
          path: 'accounts',
          name: 'gku_receipt_search',
          component: GKUAccounts,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - ЖКУ - Ручной ввод'],
            groups_menu: ['Oktapod - ЖКУ - Ручной ввод'],
            title: 'ЖКУ. Квитанции',
            icon: 'mdi-view-list'
          }
        },
        {
          path: 'accounts/:period_pay/:account',
          name: 'gku_receipt',
          component: GKUReceipt,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - ЖКУ - Ручной ввод']
          }
        }
      ]
    },
    {
      path: '/as',
      name: 'as',
      component: ASRoot,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - Учёт ПО'],
        groups_menu: ['Oktapod - Учёт ПО'],
        title: 'Учёт ПО',
        icon: 'mdi-view-list'
      },
      children: [
        {
          path: 'software/list',
          name: 'software_list',
          component: ASSoftwareList,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Учёт ПО'],
            groups_menu: ['Oktapod - Учёт ПО'],
            title: 'Список ПО',
            icon: 'mdi-view-list'
          }
        },
        {
          path: 'software/list/:id',
          name: 'software_card',
          component: ASSoftwareCard,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Учёт ПО']
          }
        },
        {
          path: 'software/select_document',
          name: 'software_select_document',
          component: ASDocumentList,
          props: { showSelect: true },
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Учёт ПО']
          }
        },
        {
          path: 'document/list',
          name: 'document_list',
          component: ASDocumentList,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Учёт ПО'],
            groups_menu: ['Oktapod - Учёт ПО'],
            title: 'Документы',
            icon: 'mdi-view-list'
          }
        },
        {
          path: 'document/list/:id',
          name: 'document_card',
          component: ASDocumentCard,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Учёт ПО']
          }
        },
        {
          path: 'reports',
          name: 'reports',
          component: ASReports,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Учёт ПО'],
            groups_menu: ['Oktapod - Учёт ПО'],
            title: 'Отчеты',
            icon: 'mdi-notebook-multiple'
          },
          children: [
            {
              path: 'acceptance-act',
              name: 'acceptance_act',
              component: ASReportAcceptanceAct,
              meta: {
                groups: ['Oktapod - Учёт ПО'],
                groups_menu: ['Oktapod - Учёт ПО'],
                title: 'Ежемесячный отчет по поступлению',
                icon: 'mdi-notebook'
              }
            },
            {
              path: 'report-accounting-software-list',
              name: 'report_accounting_software_list',
              component: ASReportAccountingSoftwareList,
              meta: {
                groups: ['Oktapod - Учёт ПО'],
                groups_menu: ['Oktapod - Учёт ПО'],
                title: 'Список программ (инвитаризация)',
                icon: 'mdi-notebook'
              }
            },
            {
              path: 'report-full-accounting-software-list',
              name: 'report_full_accounting_software_list',
              component: ASReportFullAccountingSoftwareList,
              meta: {
                groups: ['Oktapod - Учёт ПО'],
                groups_menu: ['Oktapod - Учёт ПО'],
                title: 'Список программ (расширенный)',
                icon: 'mdi-notebook'
              }
            },
            {
              path: 'report_write_off_act',
              name: 'report-write-off-act',
              component: ASReportWriteOffAct,
              meta: {
                groups: ['Oktapod - Учёт ПО'],
                groups_menu: ['Oktapod - Учёт ПО'],
                title: 'Акты на списание',
                icon: 'mdi-notebook'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // {
    //   path: '/kindergarten_101/children_list/:id',
    //   name: 'kgChildrenList101',
    //   component: KgChildrenList101,
    //   beforeEnter: requireAuthenticatedRole,
    //   meta: { groups: ['Oktapod - Детсад - 101-ОЗ (МСК)'] }
    // },
    // {
    //   path: '/kindergarten_101',
    //   name: 'kgReestrList101',
    //   component: KgReestrList101,
    //   beforeEnter: requireAuthenticatedRole,
    //   meta: {
    //     groups: ['Oktapod - Детсад - 101-ОЗ (МСК)'],
    //     groups_menu: ['Oktapod - Детсад - 101-ОЗ (МСК)'],
    //     title: 'Детсад. Реестры',
    //     icon: 'mdi-view-list'
    //   }
    // },
    {
      path: '/hemodialysis',
      name: 'hemodialysis',
      component: HemodialysisRoot,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - Гемодиализ'],
        groups_menu: ['Oktapod - Гемодиализ'],
        title: 'Гемодиализ',
        icon: 'mdi-view-list'
      },
      children: [
        {
          path: 'list',
          name: 'hemodialysis_list',
          component: HemodialysisListPerson,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Гемодиализ'],
            groups_menu: ['Oktapod - Гемодиализ'],
            title: 'Список',
            icon: 'mdi-view-list'
          }
        },
        { path: 'list/:person_id',
          name: 'hemodialysis_person',
          component: HemodialysisPerson,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Гемодиализ']
          },
          children: [
            {
              path: 'services',
              name: 'hemodialysis_services',
              component: HemodialysisListService,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Гемодиализ']
              }
            },
            {
              path: 'services/:service_id',
              name: 'hemodialysis_service',
              component: HemodialysisService,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Гемодиализ']
              }
            }
          ]
        }
      ]
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: ReportingRoot,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
          'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
          'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры'],
        groups_menu: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
          'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
          'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры'],
        title: 'Формирование отчетов',
        icon: 'mdi-view-list'
      },
      children: [
        {
          path: 'type',
          name: 'reporting_types',
          component: ReportingTypes,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
              'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
              'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры'],
            groups_menu: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
              'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
              'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры'],
            title: 'Список отчетов',
            icon: 'mdi-view-list'
          }
        },
        {
          path: 'type/:typeAbbr',
          name: 'reporting_root_report',
          component: ReportingRootReport,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
              'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
              'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры']
            // groups_menu: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры'],
            // title: 'Список отчетов',
            // icon: 'mdi-view-list'
          },
          children: [
            {
              path: 'list',
              name: 'reporting_list',
              component: ReportingList,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
                  'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
                  'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры']
              }
            },
            {
              path: 'list/:report_id',
              name: 'reporting_report',
              component: ReportingReport,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Отчеты - ЖКУ', 'Oktapod - Отчеты - ЖКУ - Менеджеры',
                  'Oktapod - Отчеты - ИТ', 'Oktapod - Отчеты - ИТ - Менеджеры',
                  'Oktapod - Отчеты - Опека', 'Oktapod - Отчеты - Опека - Менеджеры']
              }
            },
            {
              path: 'department_list',
              name: 'reporting_report_type_department_list',
              component: ReportingReportTypeDepartmentList,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Отчеты - ЖКУ - Менеджеры', 'Oktapod - Отчеты - ИТ - Менеджеры',
                  'Oktapod - Отчеты - Опека - Менеджеры']
              }
            },
            {
              path: 'department_list/:report_department_id',
              name: 'reporting_report_type_department_card',
              component: ReportingReportTypeDepartmentCard,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Отчеты - ЖКУ - Менеджеры', 'Oktapod - Отчеты - ИТ - Менеджеры',
                  'Oktapod - Отчеты - Опека - Менеджеры']
              }
            },
            {
              path: 'department_list/:report_department_id/list',
              name: 'reporting_report_department_list',
              component: ReportingReportDepartmentList,
              beforeEnter: requireAuthenticatedRole,
              meta: {
                groups: ['Oktapod - Отчеты - ЖКУ - Менеджеры', 'Oktapod - Отчеты - ИТ - Менеджеры',
                  'Oktapod - Отчеты - Опека - Менеджеры']
              }
            }
          ]
        }
      ]
    },
    {
      path: '/kindergarten',
      name: 'kindergarten',
      component: KindergartenRoot,
      beforeEnter: requireAuthenticatedRole,
      meta: {
        groups: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры'],
        groups_menu: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры'],
        title: 'Детсад.Реестры',
        icon: 'mdi-view-list'
      },
      children: [
        {
          path: 'information',
          name: 'kindergarten_information',
          component: KindergartenInformation,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры'],
            groups_menu: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры'],
            title: 'Информация',
            icon: 'mdi-view-list'
          }
        },
        {
          path: 'list',
          name: 'kindergarten_list',
          component: KindergartenList,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры'],
            groups_menu: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры'],
            title: 'Список',
            icon: 'mdi-view-list'
          }
        },
        {
          path: 'list/:registry_id',
          name: 'kindergarten_registry',
          component: KindergartenRegistry,
          beforeEnter: requireAuthenticatedRole,
          meta: {
            groups: ['Oktapod - Детсад - Реестры - Менеджеры', 'Oktapod - Детсад - Реестры']
          }
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      beforeEnter: requireAuthenticated
    },
    { path: '*', component: Home }

  ],
  base: '/oktapod',
  mode: 'history'
})
